import { makeGetSelectors } from "@/utils/redux/selector";
import { ORGANIZATION_STATE_KEY_LIST } from "@/redux/organization/slice";

export const {
	getCurrentPlan,
	getCompanyInfo,
	getCompanyDetailInfo,
	getDashboardInfo,
	getApplicationInfo,
} = makeGetSelectors("organization", ORGANIZATION_STATE_KEY_LIST);
